export default {
    STATIC: 'STATIC',
    LOGGING_IN: 'LOGGING_IN',
};
